import { useMemo } from 'react';

import { useWoopWorkloads } from './useWoopWorkloads';
import { useWorkloadScalingPolicies } from './useWorkloadScalingPolicies';
import { PreparedWorkload } from '../types';
import { prepareWorkload } from '../utils';

export const useOptimizationWorkloads = () => {
  const {
    policies,
    isLoading: policiesLoading,
    refetch: refetchPolicies,
  } = useWorkloadScalingPolicies();

  const {
    workloads,
    isLoading: workloadsLoading,
    error,
    refetch: refetchWorkloads,
  } = useWoopWorkloads();

  const preparedWorkloads = useMemo<PreparedWorkload[]>(() => {
    if (policiesLoading) {
      return [];
    }
    return (
      workloads?.map((workload) => prepareWorkload(workload, policies || [])) ||
      []
    );
  }, [workloads, policies, policiesLoading]);

  return {
    workloads: preparedWorkloads,
    isLoading: policiesLoading || workloadsLoading,
    error,
    refetch: () => {
      refetchPolicies();
      refetchWorkloads();
    },
  };
};
